var map = {
	"./Apresentacao_ao_Publico.jpeg": "2e6f",
	"./Biosseguranca.jpeg": "6dc0",
	"./Formacao_de_Equipes.jpeg": "4fb5",
	"./Gestao_de_Residuos.jpg": "0b97",
	"./Laboratorio_de_Lideranca.jpg": "2b99",
	"./Primeiros_Socorros.jpg": "d1ed",
	"./Processos_Seletivos_e_Curriculos.jpeg": "ed8b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3044";